import {environment} from '@env/environment';
import {Injectable} from '@angular/core';
import {AbstractBackendService} from '@shared/interfaces/service-classes';
import {FuenteEmisionModel} from '@app/modules/cuenta/modules/gestion-datos/fuentes-emision/model';

@Injectable()
export class FuentesEmisionUserService extends AbstractBackendService<FuenteEmisionModel, undefined> {

  buildUrlBase(): string {
    return `${environment.api.cuenta.fuentesEmision.user}`;
  }

}
